var React = require('react');

function NewWindowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.8 15.8H2.2V2.2H9V1H1V17H17V9H15.8V15.8ZM10.46 8.388L15.8 3.048V7.856L17 6.656V1H11.343L10.144 2.199H14.953L9.612 7.54L10.46 8.388Z","fill":"#000"}));
}

NewWindowInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 18 18","fill":"none","role":"img","alt":"opens in a new window","aria-label":"opens in a new window"};

module.exports = NewWindowInline;

NewWindowInline.default = NewWindowInline;
